import { createClient } from '@supabase/supabase-js';

// Always use the anon key on the client-side
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;  // Use the anon key directly

console.log('🔑 Supabase URL:', supabaseUrl);
console.log('🔑 Supabase Key:', supabaseKey ? '[Loaded ✅]' : '[MISSING ❌]');

if (!supabaseKey) {
  throw new Error('❌ Supabase key is missing! Double-check your .env or environment variables.');
}

const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;




/* Old Code */


/*

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey =
  process.env.NODE_ENV === 'server'
    ? process.env.REACT_APP_SUPABASE_SERVICE_ROLE_KEY
    : process.env.REACT_APP_SUPABASE_ANON_KEY;

console.log('🔑 Supabase URL:', supabaseUrl);
console.log('🔑 Supabase Key:', supabaseKey ? '[Loaded ✅]' : '[MISSING ❌]');

if (!supabaseKey) {
  throw new Error('❌ Supabase key is missing! Double-check your .env or environment variables.');
}

const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;

*/
